import React from 'react';

import Login from './Login/Login';
import Passwort from './Login/Password';
import PasswordRecovery from './Login/PasswordRecovery';

import Timeslots from './School/Timeslots';
import CreateTimeslot from './School/CreateTimeslot'; 
import BlockedBusinesses from './School/BlockedBusinesses';
import SchoolBusiness from './School/Business';

import OwnTimeslots from './Business/OwnTimeslots';
import SearchTimeslots from './Business/SearchTimeslots';
import Abo from './Business/Abo';
import AdditionalAbo from './Business/AdditionalAbo';
import AdditionalContingent from './Business/AdditionalContingent';
import UpgradeAbo from './Business/UpgradeAbo';

import School from './Register/School';
import Business from './Register/Business';
import UserRegistration from './Register/User';

import User from './User/User';
import UserPassword from './User/UserPassword';

import Contactperson from './User/Contactperson';
import Organisation from './User/Organisation';
import Userlist from './User/Userlist';
import NewsletterOptOut from './User/NewsletterOptOut';
import ContactMail from './User/ContactMail';

import Invite from './Mailing/Invite';

import Abos from './Operator/Abos';
import AllTimeslots from './Operator/AllTimeslots';
import Appointment from './Operator/Appointment';
import Appointments from './Operator/Appointments';
import Businesses from './Operator/Businesses';
import BusinessOperator from './Operator/BusinessOperator';
import Coupons from './Operator/Coupons';
import Coupon from './Operator/Coupon';
import Dashboard from './Operator/Dashboard';
import Registration from './Operator/Registration';
import Registrations from './Operator/Registrations';
import SchoolOperator from './Operator/SchoolOperator';
import Schools from './Operator/Schools';
import Templates from './Operator/Templates';
import TimeslotsOperator from './Operator/TimeslotsOperator';
import UserMail from './Operator/UserMail';
import Users from './Operator/UsersOperator';
import Testimonials from './Operator/Testimonials';

import PublicSearch from './Login/PublicSearch';
import AppointmentCalendar from './Login/Appointment';
import PublicContact from './Login/PublicContact';
import AppointmentContact from './Login/AppointmentContact';

const routeConfig = [
    {
        path: "/",
        component: <PublicSearch />
    },
    {
        path: "/kontakt",
        component: <PublicContact />
    },
    {
        path: "/vorfuehrtermine-kontakt",
        component: <AppointmentContact />
    },
    {
        path: "/Home/School",
        component: <PublicSearch />
    },
    {
        path: "/vorfuehrtermine",
        component: <AppointmentCalendar />
    },
    {
        path: "/Home/Appointment",
        component: <AppointmentCalendar />
    },
    {
        path: "/Login/Login",
        component: <Login />
    },
    {
        path: "/Login/Password",
        component: <Passwort />
    },
    {
        path: "/Login/PasswordRecovery",
        component: <PasswordRecovery />
    },
    {
        path: "/School/Timeslots",
        component: <Timeslots />
    },
    {
        path: "/School/CreateTimeslot",
        component: <CreateTimeslot />
    },
    {
        path: "/School/BlockedBusinesses",
        component: <BlockedBusinesses />
    },
    {
        path: "/School/Business/.*",
        component: <SchoolBusiness />
    },
    {
        path: "/Business/OwnTimeslots",
        component: <OwnTimeslots />
    },
    {
        path: "/Business/SearchTimeslots",
        component: <SearchTimeslots />
    },
    {
        path: "/Business/Abo",
        component: <Abo />
    },
    {
        path: "/Business/AdditionalAbo",
        component: <AdditionalAbo />
    },
    {
        path: "/Business/AdditionalContingent/.*",
        component: <AdditionalContingent />
    },
    {
        path: "/Business/UpgradeAbo/.*",
        component: <UpgradeAbo />
    },
    {
        path: "/Register/School",
        component: <School />
    },
    {
        path: "/Register/Business",
        component: <Business />
    },
    {
        path: "/registrierung/schule",
        component: <School />
    },
    {
        path: "/registrierung/unternehmen",
        component: <Business />
    },
    {
        path: "/Register/User/.*",
        component: <UserRegistration />
    },
    {
        path: "/User",
        component: <User />
    },
    {
        path: "/User/Password",
        component: <UserPassword />
    },
    {
        path: "/User/Contactperson",
        component: <Contactperson />
    },
    {
        path: "/User/Organisation",
        component: <Organisation />
    },
    {
        path: "/User/Users",
        component: <Userlist />
    },
    {
        path: "/User/NewsletterOptOut",
        component: <NewsletterOptOut/>
    },
    {
        path: "/User/ContactMail",
        component: <ContactMail />
    },
    {
        path: "/Mailing/Invite",
        component: <Invite />
    },
    {
        path: "/Operator/Dashboard",
        component: <Dashboard />,
    },
    {
        path: "/Operator/TimeslotsOperator",
        component: <TimeslotsOperator />,
    },
    {
        path: "/Operator/AllTimeslots",
        component: <AllTimeslots />,
    },
    {
        path: "/Operator/Registrations",
        component: <Registrations />,
    },
    {
        path: "/Operator/Registration/.*",
        component: <Registration />,
    },
    {
        path: "/Operator/Businesses",
        component: <Businesses />
    },
    {
        path: "/Operator/Business/.*",
        component: <BusinessOperator />
    },
    {
        path: "/Operator/Schools",
        component: <Schools />
    },
    {
        path: "/Operator/Abos",
        component: <Abos />
    },
    {
        path: "/Operator/School/.*",
        component: <SchoolOperator />
    },
    {
        path: "/Operator/Templates",
        component: <Templates />
    },
    {
        path: "/Operator/Users",
        component: <Users />
    },
    {
        path: "/Operator/UserMail",
        component: <UserMail />
    },
    {
        path: "/Operator/Appointment",
        component: <Appointment />
    },
    {
        path: "/Operator/Appointments",
        component: <Appointments />
    },
    {
        path: "/Operator/Coupons",
        component: <Coupons />
    },
    {
        path: "/Operator/Coupons/.*",
        component: <Coupon />
    },
    {
        path: "/Operator/Testimonials",
        component: <Testimonials />
    }
];

export default routeConfig;